import axios from 'axios';
import emitter from '@/helpers/eventBus';
import { delayedQueryDelay, TREE_URL, delayedQueryMaxFailures } from '../constants';
import { networkErrorsNotifier } from './networkErrorsNotifier';

export const BASE_URL = 'https://host2.medsafe.tech/';
export const ADD_URL = 'https://host4.medsafe.tech/';
export const POSTFIX = 'api/';
const API_URL = `${BASE_URL}${POSTFIX}${TREE_URL}`;
const LOGIN_ENDPOINT = 'login';
const LOGIN_URL = `${BASE_URL}${POSTFIX}${LOGIN_ENDPOINT}`;
const headers = {
  'Content-Type': 'application/json',
};
const postHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded',
};

class Api {
  // async get(payload) {
  //   const toReturn = await this.request(`${BASE_URL}${POSTFIX}${TREE_URL}?json=${JSON.stringify(payload)}`, 'GET');
  //   console.log(payload, toReturn);
  //   return toReturn;
  // }

  async get(payload, { isActual = () => true } = {}) {
    const queryParams = payload;
    if (payload.delayed) {
      queryParams.Name_event = `${payload.Name_event}_delayed`;
    }
    const result = await this.request(`${API_URL}?json=${JSON.stringify(queryParams)}`, 'GET');
    let toReturn;
    console.log(payload, result);
    if (payload.delayed && result?.body?.[0]) {
      toReturn = await this.getDelayedQuery({
        ...payload,
        ...result.body[0],
      }, isActual);
      console.log(toReturn);
      return toReturn;
    }
    toReturn = {
      errorText: result.errorText,
      errorType: result.errorType,
      body: result.body,
    };
    return toReturn;
  }

  async post(payload, type = null) {
    const method = 'POST';
    let toReturn;
    if (type) {
      toReturn = await this.request(`${BASE_URL}${POSTFIX}${TREE_URL}?json=${JSON.stringify(payload)}`, method);
    } else {
      const body = `json=${JSON.stringify(payload)}`;
      toReturn = await this.request(`${BASE_URL}${POSTFIX}${TREE_URL}`, method, body);
    }
    console.log(payload, toReturn);
    return toReturn;
  }

  async login(payload) {
    const body = `json=${JSON.stringify(payload)}`;
    try {
      const toReturn = await fetch(`${LOGIN_URL}`, {
        method: 'POST',
        body,
        headers: postHeaders,
      });
      const result = await toReturn.json();
      console.log(result);
      return result;
    } catch (error) {
      return error;
    }
  }

  async request(url, method, body = null) {
    try {
      const response = await fetch(url, {
        method,
        headers: body ? postHeaders : headers,
        body,
      });
      const result = await response.json();
      if (result.errorType === 1 && result.errorText === 'Incorrect token') {
        emitter.emit('message', result.errorText);
        emitter.emit('logout');
        return false;
      }
      if (result.errorType && result.errorType !== 1) {
        emitter.emit('message', result.errorText);
        return false;
      }
      if (
        result?.body?.length
        && (result.body[0]?.err_text || result.body[0].err_txt || result.body[0].error)
      ) {
        const text = result.body[0].err_txt || result.body[0].err_text || result.body[0].error;
        emitter.emit('message', text);
      }
      if (result?.body?.length && result.body[0]?.err) {
        return false;
      }
      return result;
    } catch (error) {
      emitter.emit('message', error.message);
      networkErrorsNotifier.test();
      return error;
    }
  }

  async sendLargeJson(payload) {
    console.log(payload);
    try {
      const response = await axios.post(`${ADD_URL}${POSTFIX}${TREE_URL}`, {
        json: JSON.stringify(payload),
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getFile(hash) {
    try {
      const response = await fetch(`${BASE_URL}${hash}`, {
        responseType: 'blob',
      });
      if (response.ok) {
        const result = await response.blob();
        return result;
      }
      return false;
    } catch (error) {
      return error.response.status;
    }
  }

  async uploadFile(formData, url) {
    try {
      const upload = await axios.post(`https://host2.medsafe.tech/api/${url}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return upload;
    } catch (error) {
      console.log(error);
    }
  }

  async delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async tryToGetDelayedQueryData(delayedQuery) {
    try {
      const response = await this.get({
        ...delayedQuery,
        Name_event: 'GET:delayed_result',
        delayed: false,
      });
      // нет body — сетевая/серверная ошибка, а не «ещё не готово»
      if (!Array.isArray(response?.body)) {
        return {
          done: 0,
          result: null,
          failed: true,
        };
      }
      const [data] = response.body;
      if (data) {
        return {
          ...data,
        };
      }
    } catch (error) {
      console.log(error);
      return {
        done: 0,
        result: null,
        failed: true,
      };
    }
    return {
      done: 0,
      result: null,
    };
  }

  async getDelayedQuery(delayedQuery, isActual = () => true, failures = 0) {
    // запрос устарел (сменили организацию/договор и т.п.) — прекращаем опрос
    if (!isActual()) {
      return {
        errorText: 'cancelled',
        errorType: -1,
        body: [],
        cancelled: true,
      };
    }
    const response = await this.tryToGetDelayedQueryData(delayedQuery);
    if (response.done === 1) {
      try {
        const { result } = response;
        if (result) {
          return {
            errorText: '',
            errorType: 0,
            body: JSON.parse(result),
          };
        }
        return {
          errorText: '',
          errorType: 0,
        };
      } catch (error) {
        console.log(error);
      }
      return {
        errorText: '',
        errorType: 0,
        ...response,
      };
    }
    const nextFailures = response.failed ? failures + 1 : 0;
    if (nextFailures >= delayedQueryMaxFailures) {
      return {
        errorText: 'Не удалось получить результат запроса',
        errorType: -1,
        body: [],
      };
    }
    await this.delay(delayedQueryDelay);
    return this.getDelayedQuery(delayedQuery, isActual, nextFailures);
  }
}

export default new Api();
